import { render, staticRenderFns } from "./course.vue?vue&type=template&id=0a0045fb&scoped=true"
import script from "./course.vue?vue&type=script&lang=ts"
export * from "./course.vue?vue&type=script&lang=ts"
import style0 from "./course.vue?vue&type=style&index=0&id=0a0045fb&prod&lang=scss&scoped=true"
import style1 from "./course.vue?vue&type=style&index=1&id=0a0045fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0045fb",
  null
  
)

export default component.exports